import {
	generateUtilityClass,
	generateUtilityClasses,
} from '@netx/core-components/Theme/utils';

export const ACTION_MENU_LIST_ITEM_CLASS_NAME = 'ActionMenuListItem';
export const ACTION_MENU_LIST_ITEM_CLASS_SLOTS: Array<
	keyof ActionMenuListItemClasses
> = ['root'] as const;

export type ActionMenuListItemClassSlot =
	(typeof ACTION_MENU_LIST_ITEM_CLASS_SLOTS)[number];

export interface ActionMenuListItemClasses {
	root: string;
}

export type ActionMenuListItemClassKey = keyof ActionMenuListItemClasses;

export const getActionMenuListItemUtilityClass = (slot: string) =>
	generateUtilityClass(
		ACTION_MENU_LIST_ITEM_CLASS_NAME,
		slot as ActionMenuListItemClassSlot,
	);

export const actionMenuListItemClasses: ActionMenuListItemClasses =
	generateUtilityClasses(ACTION_MENU_LIST_ITEM_CLASS_NAME, ['root']);

export default actionMenuListItemClasses;
